import React from 'react';
import { Form } from '@douyinfe/semi-ui';
import ImageSelector from '../../../ImageSelector';
import { ModuleStyleForm } from '../../components/ModuleBase/ModuleBase';
import { config } from './config';

export const SingleImageStyleForm = ({ data = {}, onChange }) => {
    const defaultData = {
        ...config.defaultProps
    };

    const handleImageChange = (value) => {
        onChange?.({ ...defaultData, ...data, image: value });
    };

    const handleStyleChange = (values) => {
        onChange?.({ ...defaultData, ...data, imageStyle: { ...data.imageStyle, ...values } });
    };

    const handleModuleStyleChange = (style) => {
        onChange?.({ ...defaultData, ...data, style });
    };

    return (
        <Form labelPosition="left" labelAlign="right">
            <div style={{ padding: '16px' }}>
                <div style={{ marginBottom: '12px', fontWeight: 600 }}>图片设置</div>
                <Form.Slot>
                    <ImageSelector
                        value={data?.image || defaultData.image}
                        onChange={handleImageChange}
                    />
                </Form.Slot>
                <Form
                    initValues={{
                        height: data?.imageStyle?.height || defaultData.imageStyle.height,
                        objectFit: data?.imageStyle?.objectFit || defaultData.imageStyle.objectFit
                    }}
                    onValueChange={handleStyleChange}
                >
                    <Form.InputNumber
                        field="height"
                        label="高度"
                        style={{ width: '100%' }}
                        suffix="px"
                    />
                    <Form.Select
                        field="objectFit"
                        label="显示模式"
                        style={{ width: '100%' }}
                    >
                        <Form.Select.Option value="fill">拉伸充满</Form.Select.Option>
                        <Form.Select.Option value="contain">保持比例</Form.Select.Option>
                        <Form.Select.Option value="cover">裁剪充满</Form.Select.Option>
                        <Form.Select.Option value="none">原始大小</Form.Select.Option>
                    </Form.Select>
                </Form>
                <ModuleStyleForm
                    style={data?.style || defaultData.style}
                    onChange={handleModuleStyleChange}
                />
            </div>
        </Form>
    );
};

export default SingleImageStyleForm;